import { Injectable } from "@angular/core";
import { APIEndpoints } from "../../../../config/apiEndpoint.config";
import { DocumentListItemDTO } from "../models/documentListItemsDTO";
import { Observable } from "rxjs";
import { ChangeDocumentContact } from "../models/changeDocumentContact";
import { map } from "rxjs/operators";
import { HttpService } from "src/app/shared/http.service";
import { PrintDocument } from "../models/printDocument";
import { UploadBuildingDocumentPhoto } from "../models/uploadBuildingDocumentPhoto";
import { DocumentListValidationItem } from "../components/document-preview/document-preview.component";
import { AddNewPersonToBuildingDto } from "src/app/shared/Models/write/AddNewPersonToBuildingDto";
import { CreateSSRDocumentDTO } from "src/app/shared/Models/write/CreateSSRDocumentDTO";
import { SetInsideSurveyTsaNoAdminDto } from "../models/setInsideSurveyTsaNoAdminDto";
import { TemplateType } from "src/app/shared/Models/enums/TemplateType.enum";
import { TemplateLanguage } from "src/app/shared/Models/enums/TemplateLanguage.enum";

@Injectable({
  providedIn: "root",
})
export class DocumentListService {
  constructor(private _http: HttpService) {}

  // tODO: remove mock
  mapWithMock(item: DocumentListItemDTO) {
    return DocumentListItemDTO.create({
      ...item,
      tsaUrl: {
        NL: "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf",
        FR: "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf",
      },
      ssrUrl: {
        NL: "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf",
        FR: "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf",
      },
    });
  }

  getDocumentListItemsByAreaId(
    areaId: string
  ): Observable<DocumentListItemDTO[]> {
    return this._http
      .get<DocumentListItemDTO[]>(
        APIEndpoints.getDocumentListItems + "/" + areaId
      )
      .pipe(map((items) => items.map(this.mapWithMock)));
  }

  getDocumentByBuildingId(
    buildingId: string
  ): Observable<DocumentListItemDTO[]> {
    return this._http
      .get<DocumentListItemDTO[]>(
        APIEndpoints.getDocumentByBuildingId + "/" + buildingId,
        true
      )
      .pipe(map((items) => items.map(this.mapWithMock)));
  }

  addGeneralRemarks(buildingId: string, remark: string) {
    return this._http.post(APIEndpoints.addGeneralRemarkToDocument, {
      buildingId,
      remark,
    });
  }

  updateDocumentContact(command: ChangeDocumentContact): Observable<any> {
    return this._http.post(APIEndpoints.updateDocumentContact, command);
  }

  setNoAdminTsa(command: SetInsideSurveyTsaNoAdminDto): Observable<any> {
    return this._http.post(APIEndpoints.setInsideSurveyTsaNoAdmin, command);
  }

  getDocumentData(item: DocumentListValidationItem) {
    let url = this.getDocumentUrl(
      item.type,
      item.lang,
      item.documentItem.getSurveyTypeByStatus(),
      item.documentItem.getSurveyId(item.documentItem.getSurveyTypeByStatus()),
      item.documentItem.areaId
    );
    // return this._http.get(url);
    return this._http.getBlob(url);
  }

  getPrintedDocumentData(item: DocumentListItemDTO) {
    let url = this.getDocumentUrl(
      TemplateType.TSA,
      item.printedLanguage,
      item.getSurveyTypeByStatus(),
      item.getSurveyId(item.getSurveyTypeByStatus()),
      item.areaId
    );
    return this._http.get(url);
  }

  private getDocumentUrl(
    type: TemplateType,
    language: TemplateLanguage,
    surveyType: string,
    surveyId: string,
    areaId: string
  ): string {
    return `/templates/report/${surveyType}/${surveyId}/${type}/${language}/${areaId}`;
  }

  CreateSSRDocument(surveyId: string) {
    return this._http.post(
      APIEndpoints.createSSRDocument,
      new CreateSSRDocumentDTO({ surveyId })
    );
  }

  printDocument(dto: PrintDocument) {
    return this._http.post(APIEndpoints.printDocument, dto);
  }

  removeContact(data: { buildingId: string; personId: string }) {
    return this._http.post(APIEndpoints.removePersonFromBuilding, data);
  }

  addContactToList(data: { buildingId: string; personId: string }) {
    return this._http.post(APIEndpoints.addExistingPersonToBuilding, data);
  }

  saveNewContactToList(data: AddNewPersonToBuildingDto): Observable<any> {
    return this._http.post(APIEndpoints.addNewPersonToBuilding, data);
  }

  uploadSignedDocument(command: UploadBuildingDocumentPhoto) {
    return this._http.post(APIEndpoints.uploadBuildingDocumentPhoto, command);
  }

  approve(buildingId: string) {
    return this._http.post(APIEndpoints.approveDocument, { buildingId });
  }

  deleteTsa(buildingId: string, remark: string) {
    return this._http.post(
      APIEndpoints.deleteTsa,
      {
        buildingId,
        remark,
      },
      true
    );
  }

  reject(buildingId: string, rejecterName: string, rejectionReason: string) {
    return this._http.post(APIEndpoints.rejectDocument, {
      buildingId,
      rejecterName,
      rejectionReason,
    });
  }

  rejectSigned(buildingId: string, rejectionReason: string) {
    return this._http.post(APIEndpoints.rejectSignedDocument, {
      buildingId,
      rejectionReason,
    });
  }

  backToPrinted(buildingId: string) {
    return this._http.post(APIEndpoints.sendBackToPrinted, { buildingId });
  }

  backToPending(buildingId: string) {
    return this._http.post(APIEndpoints.sendBackToPending, { buildingId });
  }

  isDefaultArea(areaId: string): Observable<boolean> {
    return this._http.get<boolean>(APIEndpoints.IsDefaultArea(areaId), false);
  }
}
